
(function (angular) {
    var STATE_NAME = 'app.cart.checkout.process.address';
    angular.module('mobilezuz').config(['$stateProvider', 'PAGE_ACCESS', function ($stateProvider) {
        $stateProvider.state(STATE_NAME, {
            url: '/address?addressDetails',
            checkoutViewOriginalIndex: 1,
            checkoutViewIndex: 1,
            views: {
                'checkoutProcess': {
                    templateUrl: 'views/checkout/process/address.html',
                    controller: 'CheckoutAddressCtrl as checkoutAddressCtrl',
                    resolve: {
                        zipCodeLimitLength:['Config', function (config) {
                            var _US_ZIP_CODE_LENGTH = 5;
                            return config.retailer.currencyCode === 'USD' ? _US_ZIP_CODE_LENGTH : undefined;
                        }],
                        AddressFormService: ['AddressFormService', function(AddressFormService) {
                            return AddressFormService.initAddressFormService();
                        }],
                    }
                }
            }
        });
    }]).controller('CheckoutAddressCtrl', [
        '$scope', '$rootScope', '$filter', '$q', '$timeout', 'Config', 'Api', 'User', 'ShippingTermsPopup', 'Retailer',
        'SpDeliveryAreasService', 'mDesign', 'branchArea', 'SP_SERVICES', 'CITY_TYPES', 'HOUSE_ENTRIES', 'AddressFormService',
        'DELIVERY_AREA_METHODS_PRECISION', 'PHONE_TYPES', 'Util', 'DataLayer', 'Cart', 'mDesign', 'AddressService', '$state', 'GOOGLE_MAP_ADDRESS_TYPES', 'FILTER_ADDRESS_MODE', 'GMap', 'zipCodeLimitLength',
        function ($scope, $rootScope, $filter, $q, $timeout, Config, Api, User, ShippingTermsPopup, Retailer,
                  SpDeliveryAreasService, mDesign, branchArea, SP_SERVICES, CITY_TYPES, HOUSE_ENTRIES, AddressFormService,
                  DELIVERY_AREA_METHODS_PRECISION, PHONE_TYPES, util, DataLayer, Cart, mDesign, AddressService, $state, GOOGLE_MAP_ADDRESS_TYPES, FILTER_ADDRESS_MODE, GMap, zipCodeLimitLength) {
            var checkoutProcessCtrl = $scope.checkoutProcessCtrl,
                checkoutAddressCtrl = this,
                _translate = $filter('translate'),
                _getCitiesPromise,
                _houseNumberRegExp = new RegExp(/^[0-9]+$/),
                _wasText1HouseNumberShown = false,
                _listeners = [],
                _addressComponents = ['city', 'street', 'houseNumber', 'text1', 'zipCode'],
                _ADDRESS_TYPE_MAP = {
                    city: 'city',
                    text1: 'address',
                    street: 'address',
                    zipCode: 'zipCode'
                };

            var ckoutPromoConfig = null;

            if (!checkoutProcessCtrl.isAddressFirst && !checkoutProcessCtrl.timesDetails) {
                return checkoutProcessCtrl.goToState('app.cart.checkout.process.times', 500);
            }

            checkoutProcessCtrl.nextView = nextView;
            checkoutProcessCtrl.previousView = previousView;
            checkoutProcessCtrl.validateView = validateView;
            checkoutProcessCtrl.getCityAutoCompleteOptions = getCityAutoCompleteOptions;
            checkoutProcessCtrl.getStreetAutoCompleteOptions = getStreetAutoCompleteOptions;
            checkoutProcessCtrl.onCityChange = onCityChange;
            checkoutProcessCtrl.onCityBlur = onCityBlur;
            checkoutProcessCtrl.onCityChosen = onCityChosen;
            checkoutProcessCtrl.onAddressChange = onAddressChange;
            checkoutProcessCtrl.onAddressBlur = onAddressBlur;
            checkoutProcessCtrl.onHouseNumberBlur = onHouseNumberBlur;
            checkoutProcessCtrl.onAddressChosen = onAddressChosen;
            checkoutProcessCtrl.onZipCodeBlur = onZipCodeBlur;
            checkoutProcessCtrl.onZipCodeChange = onZipCodeChange;
            checkoutProcessCtrl.getAddressAutoCompleteOptions = getAddressAutoCompleteOptions;
            checkoutProcessCtrl.extractAddressField = extractAddressField;
            checkoutProcessCtrl.isExistedInSuggestions = isExistedInSuggestions;
            checkoutProcessCtrl.onAddressInputKeydown = onAddressInputKeydown;
            checkoutProcessCtrl.openGoogleMapDialog = openGoogleMapDialog;
            checkoutProcessCtrl.onCountryBlur = onCountryBlur;
            checkoutProcessCtrl.getAddressFormFieldSettings = getAddressFormFieldSettings;

            checkoutAddressCtrl.validateText1HouseNumber = validateText1HouseNumber;
            checkoutAddressCtrl.backupAddress = {};
            checkoutAddressCtrl.editUnrecognizedAddress = editUnrecognizedAddress;
            checkoutAddressCtrl.cancelPinnedAddress = cancelPinnedAddress;
            checkoutAddressCtrl.getFieldErrorMsg = AddressFormService.getFieldErrorMsg;
            checkoutAddressCtrl.isShowAddressField = isShowAddressField;
            checkoutAddressCtrl.isDisableAddressField = isDisableAddressField;
            checkoutAddressCtrl.isDropPinRequiredStreetAndHouseNumber = isDropPinRequiredStreetAndHouseNumber;
            checkoutAddressCtrl.onDropPinAddressFieldBlur = _disableAllDropPinFields;
            checkoutAddressCtrl.editDropPinAddressField = editDropPinAddressField;
            checkoutAddressCtrl.getAddressFieldLabel = getAddressFieldLabel;
            checkoutAddressCtrl.getDropPinClarifyMessage = getDropPinClarifyMessage;

            checkoutProcessCtrl.isUseNewAddressesFeature = AddressFormService.isUseNewAddressesFeature;
            checkoutProcessCtrl.addressDetails = checkoutProcessCtrl.addressDetails || {};
            checkoutProcessCtrl.suggestedCities = [];
            checkoutProcessCtrl.suggestedAddresses = [];
            checkoutProcessCtrl.isAddressVerificationEnabled = false;
            checkoutProcessCtrl.addressVerificationText = Config.retailer.settings.addressVerificationText ? JSON.parse(Config.retailer.settings.addressVerificationText) : {};
            checkoutProcessCtrl.formErrorCtrl = {
                city: false,
                text1: false,
                zipCode: false
            };
            checkoutProcessCtrl.dropPinDisableFields = AddressFormService.getDropPinDisableFields();
            checkoutProcessCtrl.isRunAddressAutoComplete = true;
            checkoutProcessCtrl.zipCodeLimitLength = zipCodeLimitLength;
            checkoutProcessCtrl.addressCompletedMethod = 'Manual';

            Config.checkoutData.state = STATE_NAME;
            Config.checkoutData.addressDetails = checkoutProcessCtrl.addressDetails;
            checkoutProcessCtrl.isZipCodeValid = false;
            checkoutProcessCtrl.isValidFloor = true;

            checkoutProcessCtrl.ckoutPromoConfig = ckoutPromoConfig;

            ShippingTermsPopup.showWithRedirect('app.cart'); 

            User.getUserSettings().then(function (user) {
                if (!user) return;
                var address = user.addresses && user.addresses.length ? user.addresses[0] : {},
                    userPhone = {};
                angular.forEach(user.phones, function (phone) {
                    if (phone.typeVal === PHONE_TYPES.MOBILE) {
                        userPhone = phone;
                    }
                });
                
                AddressFormService.cleanAddressDataBaseOnRetailerConfig(address);

                checkoutProcessCtrl.addressDetails.phone = checkoutProcessCtrl.addressDetails.phone || userPhone.phoneNumber;
                checkoutProcessCtrl.addressDetails.id = checkoutProcessCtrl.addressDetails.id || address.id;
                checkoutProcessCtrl.addressDetails.text1 = checkoutProcessCtrl.addressDetails.text1 || address.text1 || '';
                checkoutProcessCtrl.addressDetails.text2 = checkoutProcessCtrl.addressDetails.text2 || address.text2 || '';
                checkoutProcessCtrl.addressDetails.country = checkoutProcessCtrl.addressDetails.country || address.country || '';
                checkoutProcessCtrl.addressDetails.floor = checkoutProcessCtrl.addressDetails.floor || address.floor || null;
                checkoutProcessCtrl.addressDetails.apartment = checkoutProcessCtrl.addressDetails.apartment || address.apartment || '';
                checkoutProcessCtrl.addressDetails.city = checkoutProcessCtrl.addressDetails.city || address.city;
                checkoutProcessCtrl.addressDetails.street = checkoutProcessCtrl.addressDetails.street || address.street;
                checkoutProcessCtrl.addressDetails.state = checkoutProcessCtrl.addressDetails.state || address.state;
                checkoutProcessCtrl.addressDetails.buildingCode = checkoutProcessCtrl.addressDetails.buildingCode || address.buildingCode;
                checkoutProcessCtrl.addressDetails.houseNumber = checkoutProcessCtrl.addressDetails.houseNumber || address.houseNumber;
                checkoutProcessCtrl.addressDetails.entry = checkoutProcessCtrl.addressDetails.entry || address.entry;
                checkoutProcessCtrl.addressDetails.friendlyName = checkoutProcessCtrl.addressDetails.friendlyName || ((user.firstName || '') + ' ' + (user.lastName || '')).trim() || address.friendlyName || '';
                checkoutProcessCtrl.addressDetails.zipCode = checkoutProcessCtrl.addressDetails.zipCode || address.zipCode;
                checkoutProcessCtrl.addressDetails.externalPlaceId = checkoutProcessCtrl.addressDetails.externalPlaceId || address.externalPlaceId;
                checkoutProcessCtrl.addressDetails.lat = checkoutProcessCtrl.addressDetails.lat || address.lat;
                checkoutProcessCtrl.addressDetails.lng = checkoutProcessCtrl.addressDetails.lng || address.lng;
                checkoutProcessCtrl.addressDetails.isVerified = checkoutProcessCtrl.addressDetails.isVerified || address.isVerified;
                
                checkoutProcessCtrl.isGMapWithZipCodeProvider = Config.retailer.settings.autocompleteAddressField && Config.retailer.settings.activeZipProvider && Config.retailer.settings.activeZipProvider.name === 'Get Address'

                if (Config.retailer.deliveryAreaMethod === SP_SERVICES.DELIVERY_AREA_METHODS.ZIP_CODE || checkoutProcessCtrl.deliveryAreaMethod === SP_SERVICES.DELIVERY_AREA_METHODS.CITY) {
                    getCityAutoCompleteOptions().then(function (citiesList) {
                        if (!citiesList) {
                            return;
                        }

                        var foundCity = _findCityAndSetIsStreetRequired(citiesList);
                        if (!foundCity) {
                            delete checkoutProcessCtrl.addressDetails.city;
                        }
                    });
                }
                try {
                    var addressComponents = JSON.parse(localStorage.getItem('mobileZuzTypedAreaAddressComponents'));
                    var addressFields = util.checkAddressFields(checkoutProcessCtrl.addressDetails);
                    if (addressComponents && !addressFields && !Config.retailer.settings.autocompleteAddressField) {
                        angular.extend(
                            checkoutProcessCtrl.addressDetails,
                            SpDeliveryAreasService.addressComponentsToSpAddress(addressComponents)
                        );
                    }
                } catch (err) {
                    // In case "mobileZuzTypedAreaAddressComponents" is not array
                }
                // Backup address
                angular.extend(checkoutAddressCtrl.backupAddress, checkoutProcessCtrl.addressDetails);
                // Init previous full delivery address
                angular.extend(checkoutProcessCtrl.previousFullDeliveryAddress, {
                    address: address,
                    externalPlaceId: address.externalPlaceId,
                });

                // pre-validate zipcode
                onZipCodeBlur();

                _setOrInitValueForAddressField('isShowEditAddress', checkoutProcessCtrl.addressDetails.isShowEditAddress, false);
                _setOrInitValueForAddressField('hasHouseNumberAndRoute', checkoutProcessCtrl.addressDetails.hasHouseNumberAndRoute, !checkoutProcessCtrl.isDropPinAddressNotDetected);
                _setOrInitValueForAddressField('isDisabledAddressField', checkoutProcessCtrl.addressDetails.isDisabledAddressField, false);

            });

            Retailer.getRetailerSettings().then(function (response) {
                if (checkoutProcessCtrl.isDelivery) {
                    // TODO remove checkoutProcessCtrl.streetIsRequire
                    checkoutProcessCtrl.streetIsRequire = response.deliveryAreaPrecision !== DELIVERY_AREA_METHODS_PRECISION.CITY_STREET_NOT_REQUIRED;
                    checkoutProcessCtrl.deliveryAreaMethod = response.deliveryAreaMethod;
                    // For feature address verification
                    var isEnable = Config.retailer.settings.isAddressVerificationEnabled && Config.retailer.settings.isAddressVerificationEnabled === 'true';
                    var isUseGoogleMapApi = [SP_SERVICES.DELIVERY_AREA_METHODS.POLYGON, SP_SERVICES.DELIVERY_AREA_METHODS.GOOGLE_MAPS].includes(checkoutProcessCtrl.deliveryAreaMethod);
                    checkoutProcessCtrl.isAddressVerificationEnabled = isEnable && isUseGoogleMapApi;
                    checkoutProcessCtrl.isUseGMapDeliveryMethod = isUseGoogleMapApi;
                    
                    // Track Address Details Viewed event for mobile
                    _trackAddressDetailsViewed();

                    if (
                        // is in pilot updates
                        AddressFormService.isUseNewAddressesFeature &&
                        // is GOOGLE_MAPS / POLYGON
                        checkoutProcessCtrl.isUseGMapDeliveryMethod
                    ) {
                        // GOOGLE_MAPS / POLYGON with Zip-code provider will use old form => don't need to load form settings
                        if (checkoutProcessCtrl.isGMapWithZipCodeProvider) {
                            checkoutProcessCtrl.streetIsRequire  = Config.retailer.settings.addressPrecision !== DELIVERY_AREA_METHODS_PRECISION.CITY_STREET_NOT_REQUIRED;
                            return;
                        } 
         
                        checkoutProcessCtrl.streetIsRequire = true;
                        delete Config.retailer.settings.enableDefaultCountry;

                        checkoutProcessCtrl.isGoogleMapDropPinAllow = AddressFormService.isGoogleMapDropPinAllow;
                        checkoutProcessCtrl.enableAddressFiltering = AddressFormService.enableAddressFiltering;
                        checkoutProcessCtrl.isAddressFilteringCityMode = AddressFormService.isAddressFilteringCityMode;
                        checkoutProcessCtrl.isAddressFilteringZipCodeMode = AddressFormService.isAddressFilteringZipCodeMode;
                    }
                }
                checkoutProcessCtrl.enableFloorApartment = response.enableFloorApartment;
            });

            if (!checkoutProcessCtrl.isDelivery && checkoutProcessCtrl.areas && checkoutProcessCtrl.areas.length) {
                checkoutProcessCtrl.setAreaByConfigAreaId();
            }

            _init();
            $rootScope.spMixPanel.trackPreviousProperties({startAddressTime: new Date().getTime()});

            // Listen for form errors to emit ADDRESS_FORM_ERROR_DISPLAYED event
            _listeners.push($rootScope.$on('checkout.address.delivery.setFormError', function(event, fieldName) {
                $rootScope.$emit($rootScope.SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_FORM_ERROR_DISPLAYED, {
                    fieldWithError: fieldName === 'text1' ? 'address' : fieldName || 'Unknown Field',
                    errorType: 'Validation Error'
                });
            }));
            function _init() {
                getAddressFromMap();
                if (Config.retailer.settings.enableDefaultCountry) {
                    _addressComponents.push('country');
                }
                util.getCheckoutPaymentReceiptPromotions().then(function (response) {
                    if (!response) return;
                    checkoutProcessCtrl.ckoutPromoConfig = util.processConfigPromotions(response, checkoutProcessCtrl.isDelivery);
                });
            }

            function getInvalidFormElement() {
                var addressData = checkoutProcessCtrl.addressDetails;
                var isDropPinAddress = checkoutProcessCtrl.isDropPinAddress;
                var isDropPinAddressNotDetected = checkoutProcessCtrl.isDropPinAddressNotDetected;

                return AddressFormService.getInvalidFormElement(addressData, isDropPinAddress, isDropPinAddressNotDetected);
            }

            function getAddressFromMap() {
                var adrsDetailsParams = $state.params.addressDetails;
                if (adrsDetailsParams) {
                    _handleSelectedGoogleMapAddress(JSON.parse(adrsDetailsParams));
                }
            }

            function getCityAutoCompleteOptions() {
                var city = extractAddressField('city');
                if (!city) {
                    return $q.resolve([]);
                }

                var citiesDefer = $q.defer();
                _getCitiesPromise = citiesDefer.promise;
                var getRequestFunc = checkoutProcessCtrl.isAddressVerificationEnabled ? _getCitiesFromGoogleMapApi : _getInternalCities;

                return getRequestFunc(city).then(function (data) {
                    checkoutProcessCtrl.suggestedCities = data.cities;
                    citiesDefer.resolve(data.cities);
                    return data.cities;
                }).catch(function (err) {
                    citiesDefer.reject(err);
                    return _getCitiesPromise;
                });
            }

            function getStreetAutoCompleteOptions() {
                if (!checkoutProcessCtrl.addressDetails.street) {
                    return $q.resolve([]);
                }

                return $q.resolve(_getCitiesPromise).then(function(cities) {
                    if (!cities) {
                        return $q.reject('no cities');
                    }

                    var cityId;
                    angular.forEach(cities, function (city) {
                        if (city.name === checkoutProcessCtrl.addressDetails.city) {
                            cityId = city.id;
                        }
                    });

                    if (!cityId) {
                        return $q.reject('city not found');
                    }

                    return cityId;
                }).then(function(cityId) {
                    return Api.request({
                        method: 'GET',
                        url: '/v2/addresses/streets',
                        params: {
                            term: checkoutProcessCtrl.addressDetails.street,
                            cityId: cityId,
                            size: 8
                        }
                    });
                }).then(function (data) {
                    var streetsName = [];

                    angular.forEach(data.streets, function (street) {
                        streetsName.push(street.name);
                    });

                    return streetsName;
                });
            }

            function onCityChange() {
                if (checkoutProcessCtrl.isAddressVerificationEnabled && !(checkoutProcessCtrl.isGoogleMapDropPinAllow && !checkoutProcessCtrl.addressDetails.hasHouseNumberAndRoute)) {
                    $rootScope.$emit('checkout.address.delivery.hideFormError', {
                        hiddenFields: ['city'],
                    });
                    return;
                }

                $timeout(function() {
                    $rootScope.$emit('checkout.city.change');

                    if (_getCitiesPromise) {
                        _getCitiesPromise.then(function(cities) {
                            _findCityAndSetIsStreetRequired(cities);
                        });
                    }
                }, 100);
            }

            function onZipCodeChange() {
                if (!checkoutProcessCtrl.isAddressFilteringZipCodeMode) {
                    return
                }
                if (checkoutProcessCtrl.isAddressVerificationEnabled) {
                    $scope.$emit('checkout.address.delivery.hideFormError', {
                        hiddenFields: ['zipCode'],
                    });
                    return;
                }
            }

            function _findCityAndSetIsStreetRequired(cities) {
                for (var i = 0; i < cities.length; i++) {
                    if (cities[i].name === checkoutProcessCtrl.addressDetails.city) {
                        checkoutProcessCtrl.streetIsRequire = checkoutProcessCtrl.deliveryAreaMethod === SP_SERVICES.DELIVERY_AREA_METHODS.ZIP_CODE && cities[i].type === CITY_TYPES.MULTIPLE_ZIP_CODES;
                        return cities[i];
                    }
                }
            }

            function nextView() {
                checkoutProcessCtrl.addressDetails.entry = _getEntryValue(checkoutProcessCtrl.addressDetails.entry);
                if (checkoutProcessCtrl.isAddressFirst) {
                    return checkoutProcessCtrl.goToState('app.cart.checkout.process.times');
                }
                checkoutProcessCtrl.goToState('app.cart.checkout.process.' + (checkoutProcessCtrl.isPaymentLast() ? 'summary' : 'payment'));
            }

            function previousView() {
                if (checkoutProcessCtrl.isAddressFirst) return;

                checkoutProcessCtrl.addressDetails.entry = _getEntryValue(checkoutProcessCtrl.addressDetails.entry);
                return checkoutProcessCtrl.goToState('app.cart.checkout.process.times');
            }

            //set "None" value as null
            function _getEntryValue(entry) {
                if (entry === _translate(HOUSE_ENTRIES[0])) {
                    return null;
                }
                return entry;
            }

            function validatePhone () {
                if(checkoutProcessCtrl.mobilePhone.customValidated){
                    checkoutProcessCtrl.addressDetails.phone = [
                        checkoutProcessCtrl.mobilePhone.areaCode ? checkoutProcessCtrl.mobilePhone.areaCode.toString() : '',
                        checkoutProcessCtrl.mobilePhone.customPhoneNumber ? checkoutProcessCtrl.mobilePhone.customPhoneNumber.toString() : ''
                    ].join('');
                }
                return Api.request({
                    method: 'POST',
                    url: '/v1/retailers/:rid/phone-number/is-valid',
                    data: {
                        phoneNumber: checkoutProcessCtrl.addressDetails.phone,
                        phoneId: checkoutProcessCtrl.mobilePhone.id,
                        countryCode: checkoutProcessCtrl.mobilePhone.countryCode,
                        areaCode: checkoutProcessCtrl.mobilePhone.areaCode,
                        customValidated: checkoutProcessCtrl.mobilePhone.customValidated,
                        customPhoneNumber: checkoutProcessCtrl.mobilePhone.customPhoneNumber
                    }
                });
            }

            function cancelPinnedAddress() {
                checkoutProcessCtrl.isDropPinAddress = false;
                checkoutProcessCtrl.isDropPinAddressNotDetected = false;
                AddressFormService.cancelPinnedAddress(checkoutProcessCtrl.addressDetails);
                _setOrInitValueForAddressField('hasHouseNumberAndRoute', true);
            }

            function _validateAddressFields() {
                return validatePhone().then(function (isValidPhone) {
                    if(!isValidPhone) {
                        $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_ERROR);
                        
                        // Emit address form error for phone validation
                        $rootScope.$emit($rootScope.SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_FORM_ERROR_DISPLAYED, {
                            fieldWithError: 'phone',
                            errorType: 'Validation Error'
                        });
                        
                        return mDesign.alert('{{(\'Phone number is not valid.\' | translate)}}');
                    }
                    var checkoutForm = document.querySelector('#address_form'),
                        form = angular.element(checkoutForm).data('$formController');

                    if(!checkoutForm){
                        $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_ERROR);
                        return
                    }

                    if (!checkoutProcessCtrl.addressDetails.friendlyName || !checkoutProcessCtrl.addressDetails.friendlyName.trim()) {
                        $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_ERROR);
                        return {selector: angular.element(checkoutForm.querySelector('#friendly_name'))};
                    }
                    if (!checkoutProcessCtrl.addressDetails.phone || !isValidPhone) {
                        $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_ERROR);
                        return {selector: angular.element(checkoutForm.querySelector('#phone_number')), isPhoneValid: isValidPhone};
                    }

                    if (AddressFormService.isUseNewAddressesFeature) {
                        // validate base on address form settings
                        if (checkoutProcessCtrl.isUseGMapDeliveryMethod) {
                            // special flow for Zip code Provider - 'Get Address'
                            if (checkoutProcessCtrl.isGMapWithZipCodeProvider) {
                                if (checkoutProcessCtrl.streetIsRequire && (!(checkoutProcessCtrl.addressDetails.lat && checkoutProcessCtrl.addressDetails.lng) && (!checkoutProcessCtrl.addressDetails.text1 ||
                                    !checkoutProcessCtrl.addressDetails.text1.trim()))) {
                                    $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_ERROR);
                                    
                                    // Emit address form error for required field
                                    $rootScope.$emit($rootScope.SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_FORM_ERROR_DISPLAYED, {
                                        fieldWithError: 'street',
                                        errorType: 'Required Field'
                                    });
                                    
                                    return { selector: angular.element(checkoutForm.querySelector(AddressFormService.addressFormElementIds.address)) };
                                }

                                if (!checkoutProcessCtrl.addressDetails.city || !checkoutProcessCtrl.addressDetails.city.trim() ||
                                    (form['city'] && form['city'].$invalid)) {
                                    $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_ERROR);
                                    
                                    // Emit address form error for required field
                                    if (!checkoutProcessCtrl.addressDetails.city || !checkoutProcessCtrl.addressDetails.city.trim()) {
                                        $rootScope.$emit($rootScope.SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_FORM_ERROR_DISPLAYED, {
                                            fieldWithError: 'city',
                                            errorType: 'Required Field'
                                        });
                                    }
                                    
                                    return { selector: angular.element(checkoutForm.querySelector(AddressFormService.addressFormElementIds.city)) };
                                }
                                
                            } else {
                                // normal flow
                                var element = getInvalidFormElement()
                                if (element) {
                                    $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_ERROR);
                                    return { selector: angular.element(checkoutForm.querySelector(element)) };
                                }
                            }

                        }

                        if (
                            checkoutProcessCtrl.deliveryAreaMethod === SP_SERVICES.DELIVERY_AREA_METHODS.ZIP_CODE ||
                            checkoutProcessCtrl.deliveryAreaMethod === SP_SERVICES.DELIVERY_AREA_METHODS.CITY
                        ) {
                            if (!checkoutProcessCtrl.addressDetails.city || !checkoutProcessCtrl.addressDetails.city.trim() ||
                                (form['city'] && form['city'].$invalid)) {
                                $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_ERROR);
                                return { selector: angular.element(checkoutForm.querySelector(AddressFormService.addressFormElementIds.city)) };
                            }

                            if (checkoutProcessCtrl.streetIsRequire) {
                                if (!checkoutProcessCtrl.addressDetails.street || !checkoutProcessCtrl.addressDetails.street.trim() ||
                                    (form['street'] && form['street'].$invalid)) {
                                    $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_ERROR);
                                    return { selector: angular.element(checkoutForm.querySelector(AddressFormService.addressFormElementIds.street)) };
                                }
                                if (!checkoutProcessCtrl.addressDetails.houseNumber) {
                                    return { selector: angular.element(checkoutForm.querySelector(AddressFormService.addressFormElementIds.houseNumber)) };
                                }
                            }
                        }
                    } else {
                        if (checkoutProcessCtrl.deliveryAreaMethod === SP_SERVICES.DELIVERY_AREA_METHODS.POLYGON ||
                            checkoutProcessCtrl.deliveryAreaMethod === SP_SERVICES.DELIVERY_AREA_METHODS.GOOGLE_MAPS
                        ) {
                            if (checkoutProcessCtrl.streetIsRequire && (!(checkoutProcessCtrl.addressDetails.lat && checkoutProcessCtrl.addressDetails.lng) && (!checkoutProcessCtrl.addressDetails.text1 ||
                                !checkoutProcessCtrl.addressDetails.text1.trim()))) {
                                return {selector: angular.element(checkoutForm.querySelector(AddressFormService.addressFormElementIds.address))};
                            }
                        }
                        if (!checkoutProcessCtrl.addressDetails.city || !checkoutProcessCtrl.addressDetails.city.trim() ||
                            (form['city'] && form['city'].$invalid)) {
                            return {selector: angular.element(checkoutForm.querySelector(AddressFormService.addressFormElementIds.city))};
                        }
                        if (checkoutProcessCtrl.streetIsRequire && (
                            checkoutProcessCtrl.deliveryAreaMethod === SP_SERVICES.DELIVERY_AREA_METHODS.ZIP_CODE ||
                            checkoutProcessCtrl.deliveryAreaMethod === SP_SERVICES.DELIVERY_AREA_METHODS.CITY
                        )) {
                            if (!checkoutProcessCtrl.addressDetails.street || !checkoutProcessCtrl.addressDetails.street.trim() ||
                                (form['street'] && form['street'].$invalid)) {
                                return {selector: angular.element(checkoutForm.querySelector(AddressFormService.addressFormElementIds.street))};
                            }
                            if (!checkoutProcessCtrl.addressDetails.houseNumber) {
                                return {selector: angular.element(checkoutForm.querySelector(AddressFormService.addressFormElementIds.houseNumber))};
                            }
                        }
                    }

                });

            }

            function _validatePickupFields() {
                return validatePhone().then(function (isValidPhone) {
                    if(!isValidPhone) {
                        // Emit address form error for phone validation in pickup
                        $rootScope.$emit($rootScope.SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_FORM_ERROR_DISPLAYED, {
                            fieldWithError: 'phone',
                            errorType: 'Invalid Phone'
                        });
                        
                        return mDesign.alert('Phone number is not valid.');
                    }
                    var checkoutForm = document.querySelector('#address_form');
                    if (!checkoutProcessCtrl.addressDetails.friendlyName || !checkoutProcessCtrl.addressDetails.friendlyName.trim()) {
                        // Emit address form error for required friendlyName field
                        $rootScope.$emit($rootScope.SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_FORM_ERROR_DISPLAYED, {
                            fieldWithError: 'address',
                            errorType: 'Required Field'
                        });
                        
                        return {selector: angular.element(checkoutForm.querySelector('#friendly_name'))};
                    }
                    if (!checkoutProcessCtrl.addressDetails.phone || !isValidPhone) {
                        return {selector: angular.element(checkoutForm.querySelector('#phone_number')), isPhoneValid: isValidPhone};
                    }
                    if (!branchArea) {
                        return {msg: 'Pickup location is required'};
                    }
                    if (checkoutProcessCtrl.areas && checkoutProcessCtrl.areas.length && !(checkoutProcessCtrl.timesDetails && checkoutProcessCtrl.timesDetails.branchArea)) {
                        return {msg: 'Pickup location is required'};
                    }
                });

            }

            function validateView(defer, options) {
                var emptyFieldErr = checkoutProcessCtrl.isDelivery ? _validateAddressFields() : _validatePickupFields();

                return emptyFieldErr.then(function (emptyFieldError) {

                    if (!checkoutProcessCtrl.isDelivery || !!emptyFieldError) {

                        if (emptyFieldError && (emptyFieldError.selector && emptyFieldError.selector[0] || !emptyFieldError.isPhoneValid)) {
                            setTimeout(function () {
                                var checkoutContainer = document.querySelector('.checkout-container');
                                if (checkoutContainer && emptyFieldError.selector[0]) {
                                    angular.element(checkoutContainer).scrollTop(emptyFieldError.selector[0].offsetTop, 100);
                                }
                            });
                        }

                        return emptyFieldError;
                    }

                    var houseNumberErr = _validateText1HouseNumber();
                    if (houseNumberErr) {
                        $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_ERROR);
                        return houseNumberErr;
                    }

                    $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_SUCCESSFULLY_SUBMITTED, {
                        endAddressTime: new Date().getTime(),
                        address: checkoutProcessCtrl.addressDetails,
                        usedDropPin: checkoutProcessCtrl.isDropPinAddress || false,
                        deliveryAreaMethod: checkoutProcessCtrl.deliveryAreaMethod,
                        allRequiredFieldsFilled: true,
                        addressCompletedMethod: checkoutProcessCtrl.addressCompletedMethod
                    });
                    return checkoutProcessCtrl.getDeliveryTimes(defer, options);
                });
            }

            /**
             * Wrapper for _validateText1HouseNumber, to focus on the returned selector
             * @public
             *
             * @returns {Promise<void>|void}
             */
            function validateText1HouseNumber() {
                var promise = _validateText1HouseNumber();
                if (!promise) {
                    return;
                }

                return promise.then(function(err) {
                    if (err.selector) {
                        err.selector.focus();
                    }
                });
            }

            /**
             * Validates the text1 contains a house number
             * Returns a validateView format error after showing the dialog
             * @private
             *
             * @returns {Promise<Object>|void}
             */
            function _validateText1HouseNumber() {
                var isIgnoreValidation
                
                // TODO remove pilot check 
                if(AddressFormService.isUseNewAddressesFeature){
                    isIgnoreValidation = [
                        _wasText1HouseNumberShown,
                        !checkoutProcessCtrl.isDelivery,
                        !checkoutProcessCtrl.addressDetails.text1,
                        checkoutProcessCtrl.addressDetails.houseNumber,
                        !checkoutProcessCtrl.isUseGMapDeliveryMethod, 
                        !checkoutProcessCtrl.streetIsRequire,
                        //checkoutProcessCtrl.addressDetails.externalPlaceId,
                        //checkoutProcessCtrl.addressDetails.lat && checkoutProcessCtrl.addressDetails.lng,
                    ].some(function (value) {
                        return value;
                    });
                }else{
                    var deliveryAreaPrecision = $rootScope.config.retailer.deliveryAreaPrecision;
                    isIgnoreValidation = [
                        _wasText1HouseNumberShown,
                        !checkoutProcessCtrl.isDelivery,
                        !checkoutProcessCtrl.addressDetails.text1,
                        checkoutProcessCtrl.addressDetails.houseNumber,
                        //checkoutProcessCtrl.addressDetails.externalPlaceId,
                        //checkoutProcessCtrl.addressDetails.lat && checkoutProcessCtrl.addressDetails.lng,
                        deliveryAreaPrecision !== DELIVERY_AREA_METHODS_PRECISION.PRECISE_LOCATION && deliveryAreaPrecision !== DELIVERY_AREA_METHODS_PRECISION.CITY
                    ].some(function (value) {
                        return value;
                    });
                }
                if (isIgnoreValidation) {
                    return;
                }

                var _text1 = checkoutProcessCtrl.addressDetails.text1;
                var splitAddress = _text1.replace(/,/g, ' ');
                splitAddress = splitAddress.replace(/\s+/g, ' ');
                splitAddress = splitAddress.split(' ');

                var hasHouseNumber = splitAddress.length >= 2 && splitAddress.some(function(word) {
                    return _houseNumberRegExp.test(word);
                });
                if (hasHouseNumber) {
                    return;
                }

                _wasText1HouseNumberShown = true;
                return mDesign.dialog({
                    focusOnOpen: false,
                    clickOutsideToClose: true,
                    templateUrl: 'views/templates/address-number-warning.html',
                    controller: ['$scope', function ($scope) {
                        $scope.hide = mDesign.hide;
                    }]
                }).then(function() {
                    return { selector:  angular.element(document.querySelector(AddressFormService.addressFormElementIds.address)) };
                });
            }

            function _sendDataLayerEvent() {
                var cartLineProducts = [];
                angular.forEach(Cart.lines, function (line) {
                    if(line && line.product && line.product.id) {
                        line.product.quantity = line.quantity;
                        cartLineProducts.push(line.product);
                    }
                });
                DataLayer.push(DataLayer.EVENTS.CHECKOUT, {products: cartLineProducts, data: {step: 2, option: 'user address'}});
            }

            _listeners.push($rootScope.$on('cart.update.complete', _sendDataLayerEvent));

            util.destroyListeners($scope, _listeners);

            Cart.save();

            function onCityBlur(event) {
                if(_isClickToSuggestion(event)) return;

                var _isCityChanged = _isLocationChanged('city');
                _handleOnLocationBlur('city');

                if(AddressFormService.isUseNewAddressesFeature){
                    if (checkoutProcessCtrl.isAddressVerificationEnabled) {
                        var city = extractAddressField('city');
                        var isExisted = isExistedInSuggestions(_ADDRESS_TYPE_MAP.city, city, checkoutProcessCtrl.suggestedCities);
                        if (!isExisted) {
                            $rootScope.$emit('checkout.address.delivery.setFormError', 'city');
                        } else {
                            $rootScope.$emit('checkout.address.delivery.hideFormError', {
                                hiddenFields: ['city'],
                            });
                        }

                        if(checkoutProcessCtrl.isAddressFilteringCityMode && _isCityChanged){
                            checkoutProcessCtrl.suggestedAddresses = [];
                            checkoutProcessCtrl.addressDetails.text1 = '';
                            checkoutProcessCtrl.addressDetails.street = '';
                            checkoutProcessCtrl.addressDetails.houseNumber = '';
                            checkoutProcessCtrl.addressDetails.zipCode = '';
                        }
                    }
                } else {
                    if (checkoutProcessCtrl.isAddressVerificationEnabled) {
                        var city = extractAddressField('city');
                        var isExisted = isExistedInSuggestions(_ADDRESS_TYPE_MAP.city, city, checkoutProcessCtrl.suggestedCities);
                        if (!isExisted) {
                            $rootScope.$emit('checkout.address.delivery.setFormError', 'city');
                        } else {
                            $rootScope.$emit('checkout.address.delivery.hideFormError', {
                                hiddenFields: ['city'],
                            });
                        }
                    }
                }
            }

            function onZipCodeBlur() {
                if (!checkoutProcessCtrl.isAddressFilteringZipCodeMode) {
                    return;
                }
                
                var _isZipCodeChanged = _isLocationChanged('zipCode');
                _handleOnLocationBlur('zipCode');

                if (checkoutProcessCtrl.isAddressVerificationEnabled && _isZipCodeChanged) {
                    checkoutProcessCtrl.suggestedAddresses = [];
                    checkoutProcessCtrl.suggestedCities = [];
                    checkoutProcessCtrl.addressDetails.text1 = '';
                    checkoutProcessCtrl.addressDetails.city = '';
                }
                
                if (checkoutProcessCtrl.isAddressVerificationEnabled) {
                    var zipCode = extractAddressField('zipCode');
                    if (!zipCode) {
                        return $q.resolve([]);
                    }

                    //generate another promise that will return the full cities array (no only names)
                    var zipCodesDefer = $q.defer();
                    var getRequestFunc = _getZipCodeFromGoogleMapApi;

                    return getRequestFunc(zipCode).then(function (data) {
                        checkoutProcessCtrl.suggestedZipCodes = data.zipCodes;
                        var isExisted = isExistedInSuggestions(_ADDRESS_TYPE_MAP.zipCode, zipCode, checkoutProcessCtrl.suggestedZipCodes);
                        if (!isExisted) {
                            $rootScope.$emit('checkout.address.delivery.setFormError', 'zipCode');
                            checkoutProcessCtrl.isZipCodeValid = false;
                        } else {
                            $rootScope.$emit('checkout.address.delivery.hideFormError', {
                                hiddenFields: ['zipCode'],
                            });
                            checkoutProcessCtrl.isZipCodeValid = !!checkoutProcessCtrl.suggestedZipCodes.length;
                        }

                        zipCodesDefer.resolve(data.zipCodes);
                        return data.zipCodes;
                    }).catch(function (err) {
                        zipCodesDefer.reject(err);
                    });
                }
            }

            function onCityChosen($event) {
                var cityComponent = $event && $event.option && $event.option.component;
                
                if ($event.option.placeId) {
                    cityComponent.placeId = $event.option.placeId;
                }

                if (cityComponent) {
                    angular.extend(checkoutProcessCtrl.addressDetails, cityComponent);
                    $rootScope.$emit('checkout.address.delivery.hideFormError', {
                        hiddenFields: ['city'],
                    });
                }
                
                onCityBlur();
                return;
            }

            /**
             * @param {string} field field of address
             * @returns { string | null }
             */
            function extractAddressField(field) {
                return AddressFormService.extractAddressField(field, checkoutProcessCtrl.addressDetails);
            }

            function _getInternalCities(cityQuery) {
                return AddressService.getInternalCities(cityQuery);
            }
            
            /**
             * @param {string} cityQuery 
             */
            function _getCitiesFromGoogleMapApi(cityQuery) {
                return AddressService.getCitiesFromGoogleMapApi(cityQuery);
            }

            function _getZipCodeFromGoogleMapApi(zipCode) {
                return AddressService.getZipCodeFromGoogleMapApi(zipCode, '', zipCode, true);
            }

            function getAddressAutoCompleteOptions(fieldName, isForce) {
                if (!checkoutProcessCtrl.isRunAddressAutoComplete && !isForce) {
                    return $q.resolve([]);
                }

                var addressQuery = extractAddressField(fieldName);
                var _addressFilteringMode = AddressFormService.isUseNewAddressesFeature && checkoutProcessCtrl.enableAddressFiltering && AddressFormService.addressFiltering ? AddressFormService.addressFiltering : null;

                // Call google api
                return AddressService.getAddressAutoCompleteOptions(addressQuery, {
                    addressFilteringMode:  _addressFilteringMode,
                    placeId: checkoutProcessCtrl.addressDetails.placeId,
                    city: checkoutProcessCtrl.addressDetails.city,
                    zipCode: checkoutProcessCtrl.addressDetails.zipCode,
                    languageId: $rootScope.config.language.id
                }).then(function (addresses) {
                    checkoutProcessCtrl.suggestedAddresses = addresses;
                    checkoutProcessCtrl.addressCompletedMethod = 'AutoComplete';

                    // Emit ECOM-17455 No Results Found Street event if no addresses found
                    if (!addresses || addresses.length === 0) {
                        $rootScope.$emit($rootScope.SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_NO_RESULTS_FOUND_STREET, {
                            searchedAddress: addressQuery || '',
                            filterType: checkoutProcessCtrl.enableAddressFiltering ? 'Enabled' : 'Disabled',
                            mobileOnePagerCheckout: true
                        });
                    } else {
                        // Emit ECOM-17455 Address Entered 
                        var inputAddressType = addresses.some(function(i) {
                                return i.placeTypes && i.placeTypes.indexOf('postal_code') !== -1;
                            }) 
                            ? $rootScope.SP_SERVICES.MIXPANEL_VALUES.FILTERING_METHOD.POSTAL_CODE 
                            : $rootScope.SP_SERVICES.MIXPANEL_VALUES.FILTERING_METHOD.ADDRESS;

                        $rootScope.$emit($rootScope.SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_ENTERED, {
                            inputType: inputAddressType,
                            addressValue: addressQuery,
                            inputValid: true
                        });
                    }

                    return addresses;
                });
            }

            function onAddressChange(fieldName) {
                if (checkoutProcessCtrl.isAddressVerificationEnabled) {
                    $rootScope.$emit('checkout.address.delivery.hideFormError', {
                        hiddenFields: [fieldName],
                    });
                }
            }
            
            function onAddressBlur(event, fieldName) {
                if(_isClickToSuggestion(event)) return;

				var validatedResult = AddressFormService.onAddressBlur(fieldName, checkoutAddressCtrl.backupAddress, checkoutProcessCtrl.addressDetails, checkoutProcessCtrl.suggestedAddresses);
				if (validatedResult) {
					if (!validatedResult.isValid) {
                        $rootScope.$emit('checkout.address.delivery.setFormError', fieldName);
					} else {
                        $rootScope.$emit('checkout.address.delivery.hideFormError', {
                            hiddenFields: [fieldName],
                        });

						if (validatedResult.suggestion) {
                            onAddressChosen({ option: validatedResult.suggestion }, fieldName);
						}
					}
				}

                _handleOnLocationBlur(fieldName);
            } 

            function onHouseNumberBlur() {
                var fieldName = 'houseNumber';

                var _isAddressChanged = _isLocationChanged(fieldName);
                if(_isAddressChanged){
                    AddressFormService.cleanAddressDataBaseOnRetailerConfig(checkoutProcessCtrl.addressDetails);
                }
            }
            
            function _getFilterType() {
                if (Config && Config.retailer && Config.retailer.settings && Config.retailer.settings.enableAddressFiltering) {
                    if (Config.retailer.settings.addressFiltering === 2) {
                        return 'Zip Code';
                    } else if (Config.retailer.settings.addressFiltering === 1) {
                        return 'City';
                    }
                }
                return 'Address'; // Default fallback
            }
            function onAddressChosen($event, fieldName) {
                var addressComponent = $event && $event.option && $event.option.component;
                if (addressComponent) {
                    // Emit ECOM-17455 Street Autocomplete Search Result Clicked event
                    $rootScope.$emit($rootScope.SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_STREET_AUTOCOMPLETE_SEARCH_RESULT_CLICKED, {
                        searchedAddress: (addressComponent.description || checkoutProcessCtrl.addressDetails.text1 || ''),
                        searchResultsCount: checkoutProcessCtrl.suggestedAddresses ? checkoutProcessCtrl.suggestedAddresses.length : 0,
                        filterType: _getFilterType(),
                        mobileOnePagerCheckout: true
                    });

                    return AddressFormService.onAddressChosen(addressComponent.externalPlaceId, $rootScope.config.language.id).then(function (address) {
                        checkoutProcessCtrl.isRunAddressAutoComplete = false;
                        angular.extend(checkoutProcessCtrl.addressDetails, address);
                        angular.extend(checkoutAddressCtrl.backupAddress, checkoutProcessCtrl.addressDetails);
                        $rootScope.$emit('checkout.address.delivery.hideFormError', {
                            hiddenFields: ['city', 'text1', 'street'],
                        });
                    }).finally(function () {           
                        getAddressAutoCompleteOptions(fieldName, true);
                        onAddressBlur(null, fieldName);
                    });
                }
            }
            
            /**
             * @param {'city' | 'address'} addressType
             * @param {string} value 
             * @param {any[]} suggestions suggestedCities | suggestedAddresses
             * @returns boolean
             */
            function isExistedInSuggestions(addressType, value, suggestions) {
                return AddressFormService.isExistedInSuggestions(checkoutProcessCtrl.addressDetails, addressType, value, suggestions);
            }

            /**
             * @param {any} event 
             * @param {string} errorField address field
             */
            function _setFormErrorEvent(event, errorField) {
                checkoutProcessCtrl.formErrorCtrl[errorField] = true;
            }

            /**
             * @param {any} event 
             * @param {{hiddenFields: string[]}} emitterData list address field
             */
            function _hideFormErrorEvent(event, emitterData) {
                angular.forEach(emitterData.hiddenFields, function (field) {
                    checkoutProcessCtrl.formErrorCtrl[field] = false;
                });
            }

            /**
             * @param {any} event 
             * @param {string} selector element selector
             */
            function _triggerInputBlur(event, selector) {
                var checkoutForm = document.querySelector('#address_form');
                var inputCityElement = checkoutForm && angular.element(checkoutForm.querySelector(selector));
                if (inputCityElement) {
                    inputCityElement.triggerHandler('blur');
                }
            }

            function onAddressInputKeydown() {
                if (checkoutProcessCtrl.isAddressVerificationEnabled) {
                    checkoutProcessCtrl.isRunAddressAutoComplete = true;
                }
            }

            function _handleSelectedGoogleMapAddress(selectedAddress) {
                if (!selectedAddress) {
                    return;
                }

                
                _disableAllDropPinFields();
                checkoutProcessCtrl.isDropPinAddress = true;
                checkoutProcessCtrl.isDropPinAddressNotDetected = !selectedAddress.hasHouseNumberAndRoute;
                $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_ERROR);
                var _address = AddressFormService.onDroppedPinAddress(selectedAddress);
                // Emit ECOM-17455 Drop Pin Used event
                var addressPined = (_address.text1 || _address.street || '') + ' ' + (_address.houseNumber || '') + ' ' + (_address.city || '');
                $rootScope.$emit($rootScope.SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_DROP_PIN_USED, {
                    addressPined: addressPined.trim()
                });
                angular.extend(checkoutProcessCtrl.addressDetails, _address);

                $rootScope.$emit('checkout.address.delivery.hideFormError', {
                    hiddenFields: ['text1', 'city'],
                });
                angular.extend(checkoutAddressCtrl.backupAddress, checkoutProcessCtrl.addressDetails);

                if(selectedAddress.zipCode){
                    onZipCodeBlur();
                }
            }

            function openGoogleMapDialog() {
                var _defaultLocation = AddressFormService.getDefaultLocation(checkoutProcessCtrl.addressDetails);

                if (window.cordova) {
                    return goToGoogleMapSelectPage(_defaultLocation);
                }

                mDesign.dialog({
                    clickOutsideToClose: true,
                    templateUrl: 'views/templates/google-map-dialog.html',
                    controller: 'GoogleMapDialogCtrl as googleMapDialogCtrl',
                    locals: {
                        defaultLocation: _defaultLocation
                    }
                }).then(_handleSelectedGoogleMapAddress);
            }

            function goToGoogleMapSelectPage(_defaultLocation){
              $state.go("app.cart.checkout.process.map", { from: STATE_NAME, defaultLocation: _defaultLocation });
            }

            function _isLocationChanged(field) {
                return AddressFormService.isLocationChanged(field, checkoutAddressCtrl.backupAddress, checkoutProcessCtrl.addressDetails);
            }

            function _handleOnLocationBlur(emittedField) {
                AddressFormService.handleOnLocationBlur(emittedField, checkoutAddressCtrl.backupAddress, checkoutProcessCtrl.addressDetails, checkoutProcessCtrl.previousFullDeliveryAddress.address);
            }

            function onCountryBlur() {
                $timeout(function () {
                    _handleOnLocationBlur('country');
                }, 300);
            }

            /**
             * Set value for address field
             * @param {string} field 
             * @param {any} value 
             * @param {any} initialValue 
             */
            function _setOrInitValueForAddressField(field, value, initialValue) {
                AddressFormService.setOrInitValueForAddressField(checkoutProcessCtrl.addressDetails, field, value, initialValue);
            }

            function _isClickToSuggestion(event){
                // if click to choose suggestion, disable blur event temporarily
                var _parentTargetClickId = event && event.relatedTarget && event.relatedTarget.parentElement ? event.relatedTarget.parentElement.id : null;
                if (_parentTargetClickId && _parentTargetClickId.startsWith('sp_autocomplete_')) {
                    return true;
                }
                return false;
            }

            /**
             * Edit unrecognized address
             */
            function editUnrecognizedAddress() {
                if (!checkoutProcessCtrl.addressDetails.isDisabledAddressField) {
                    return;
                }
                var text1InputRef = document.getElementById('address_input');
                if (text1InputRef) {
                    checkoutProcessCtrl.addressDetails.isDisabledAddressField = false;
                    $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_ERROR);
                    $timeout(function () {
                        text1InputRef.focus();
                    }, 0);
                }
            }

            function isShowAddressField(fieldName){
                return AddressFormService.isShowAddressField(fieldName, checkoutProcessCtrl.isDropPinAddress, checkoutProcessCtrl.isDropPinAddressNotDetected);
            }

            function isDisableAddressField(filteringMode){
                return AddressFormService.isDisableAddressField(filteringMode, checkoutProcessCtrl.addressDetails);
            }

            function isDropPinRequiredStreetAndHouseNumber(){
                return AddressFormService.isDropPinRequiredStreetAndHouseNumber(checkoutProcessCtrl.isDropPinAddress, checkoutProcessCtrl.isDropPinAddressNotDetected);
            }

            function editDropPinAddressField(elementSelector, field){
                var _element = document.querySelector(elementSelector);
                if (_element) {
                    checkoutProcessCtrl.dropPinDisableFields[field] = false;
                    $timeout(function () {
                        _element.focus();
                    }, 0);
                }
            }

            function getAddressFieldLabel(fieldName, options) {
                return AddressFormService.getAddressFieldLabel(fieldName, $rootScope.config.language.id, options);
            }

            function getAddressFormFieldSettings(fieldName) {
                return AddressFormService.getAddressFormFieldSettings(fieldName);
            }

            function _disableAllDropPinFields() {
                AddressFormService.disableAllDropPinFields(checkoutProcessCtrl.dropPinDisableFields);
            }

            function getDropPinClarifyMessage() {
                return AddressFormService.getDropPinClarifyMessage($rootScope.config.language.culture);
            }

            function _trackAddressDetailsViewed() {
                var isDelivery = checkoutProcessCtrl.isDelivery;
                var configuredFields = ['friendlyName', 'phone']; // Base fields for all delivery methods (mobile uses friendlyName instead of fullname)
                var requiredFields = ['friendlyName', 'phone']; // Base required fields for all delivery methods
                
                // Add address fields only for delivery (not pickup)
                if (isDelivery) {
                    // Always include basic address fields for delivery
                    configuredFields.push('street', 'city');
                    requiredFields.push('street', 'city');
                    
                    // Process address form settings for mobile
                    var addressFormSettings = util.tryParseJson(Config.retailer.settings.addressFormSettings) || {};
                    var addressFields = ['zipCode', 'apartment', 'entrance', 'buildingCode', 'state', 'text2', 'floor'];
                    
                    // Add configured address fields
                    addressFields.forEach(function(fieldName) {
                        var fieldConfig = addressFormSettings[fieldName];
                        if (fieldConfig && fieldConfig.isEnabled) {
                            configuredFields.push(fieldName);
                            if (fieldConfig.isMandatory) {
                                requiredFields.push(fieldName);
                            }
                        }
                    });
                    
                    // Add house number if separate street/house fields are enabled
                    if (Config.retailer.settings.addressFormSeparateStreetHouse === 'true') {
                        var houseNumberConfig = addressFormSettings.houseNumber;
                        if (houseNumberConfig && houseNumberConfig.isEnabled) {
                            configuredFields.push('houseNumber');
                            if (houseNumberConfig.isMandatory) {
                                requiredFields.push('houseNumber');
                            }
                        }
                    }
                }
                
                // Determine filtering method based on configuration
                var filteringMethod = SP_SERVICES.MIXPANEL_VALUES.FILTERING_METHOD.NONE;
                if (Config.retailer.settings.enableAddressFiltering) {
                    if (Config.retailer.settings.addressFiltering === 2) { // ZIP_CODE mode
                        filteringMethod = SP_SERVICES.MIXPANEL_VALUES.FILTERING_METHOD.ZIP_CODE;
                    } else if (Config.retailer.settings.addressFiltering === 1) { // CITY mode
                        filteringMethod = SP_SERVICES.MIXPANEL_VALUES.FILTERING_METHOD.CITY;
                    }
                }
                
                $rootScope.$emit($rootScope.SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_DETAILS_VIEWED, {
                    filteringMethod: isDelivery ? filteringMethod : SP_SERVICES.MIXPANEL_VALUES.FILTERING_METHOD.NONE,
                    dropPinEnabled: isDelivery && (Config.retailer.settings.isGoogleMapDropPinAllow === 'true' || Config.retailer.settings.isGoogleMapDropPinAllow === true),
                    configuredFieldsShown: configuredFields,
                    requiredFields: requiredFields,
                    mobileOnePagerCheckout: true // Mobile uses one-pager checkout
                });
            }

            // TODO clear event setFormError, hideFormError after pilot done
            _listeners.push($rootScope.$on('checkout.address.delivery.setFormError', _setFormErrorEvent));
            _listeners.push($rootScope.$on('checkout.address.delivery.hideFormError', _hideFormErrorEvent));
            _listeners.push($rootScope.$on('checkout.address.delivery.blurInput', _triggerInputBlur));
        }]);
})(angular);
